import shareIcon from 'public/static/images/dealer_pages/share.svg';
import { screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { DealerPagesEventType, SocialSharing } from 'lib/EventSchema';
import { trackDealerPagesClick } from 'lib/Tracking/DealerPages';
import { trackShare } from 'lib/Tracking';
import ShareDropdown from 'components/Shared/ShareDropdown';
import navigatorShare from 'lib/navigatorShare';
import Action from './Action';
import Icon from '../../Shared/Icon';

function trackShareClick(platform: string, dealerPageUrl: string): void {
  trackDealerPagesClick({
    type: DealerPagesEventType.share_click,
    label: platform,
    dealerPageUrl,
  });
  trackShare({
    category: 'dealer_page',
    type: 'dealer_page',
    platform,
    url: `https://autolist.com/dealers/${dealerPageUrl}`,
  });
}

const Share = ({ slug, title }: { slug: string; title: string }): JSX.Element => {
  const { t } = useTranslation();

  function onClick(): void {
    navigatorShare({
      title,
      text: 'Check out this car dealership!',
      url: `https://www.autolist.com/dealers/${slug}`,
    });

    trackDealerPagesClick({
      type: DealerPagesEventType.share_click,
      label: SocialSharing.share_text,
      dealerPageUrl: slug,
    });
  }

  const dealerPageUrl = `https://www.autolist.com/dealers/${slug}`;
  return (
    <div className="share-container">
      <button onClick={onClick} className="share-button">
        <Icon image={shareIcon} />
        <Action>{t('dealerPages.share') as string}</Action>
      </button>
      <div className="share-dropdown">
        <ShareDropdown
          url={dealerPageUrl}
          shareText={'Check out this car dealership!'}
          shareSubject={title}
          onEmailClick={(): void => trackShareClick(SocialSharing.email, slug)}
          onFacebookClick={(): void => trackShareClick(SocialSharing.facebook, slug)}
          onTwitterClick={(): void => trackShareClick(SocialSharing.twitter, slug)}
          onCopyClick={(): void => trackShareClick(SocialSharing.copy, slug)}
        />
      </div>

      <style jsx>{`
        .share-container {
          position: relative;
          width: 100px;
          height: 40px;
        }

        .share-button {
          display: flex;
          margin-bottom: 18px;
          border: none;
          background: white;
          margin: 0;
          padding: 0;
        }

        .share-dropdown {
          display: none;
          position: absolute;
          top: 30px;
          left: -29px;
          z-index: 10;
          background: white;
        }

        @media (min-width: ${screen.smMin}) {
          .share-container:hover .share-dropdown {
            display: flex;
          }
        }
      `}</style>
    </div>
  );
};

export default Share;
